

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeMonitoringGds } from "@/store/modules/MonitoringGdsStore";
import MonitoringGdsSvc from "@/services/MonitoringGdsService";
import MonitoringGdsDetail from "./MonitoringGdsDetail.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    MonitoringGdsDetail
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringGdsList extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string;

  storeMonitoring = storeMonitoringGds;
  showDetail = false;
  editData: any = null;
  isReadonly = false;
  isReadOnly!: () => boolean;

  get pageReadOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Tanggal", value: "tanggal", width: "120px" },
    { text: "Diagnosis (Dx)", value: "diagnosis" },
    { text: "Entri", value: "jumlah", sortable: false, width: "90px" },
    { text: "Aksi", value: "actions", sortable: false, width: "120px" }
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    await storeMonitoringGds.getByRegister(this.register);
  }

  tambah() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = this.pageReadOnly;
    this.showDetail = true;
  }

  cetakPdf(item: any) {
    MonitoringGdsSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    if (!confirm("Hapus lembar monitoring GDS ini?")) return;
    try {
      const resp = await MonitoringGdsSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus");
        this.loadData();
      }
    } catch {
      // handled by service
    }
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }

  formatDate(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM/YYYY");
  }
}
